import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {HttpParams} from '@angular/common/http';
import {map} from 'rxjs/operators';
import {HttpService} from './http.service';

@Injectable()
export class LevelsApi {
    private readonly apiController: string = '/api/levels';

    constructor(private api: HttpService) {
    }

    list(search: string, pageNumber: number, pageSize: number, orderBy: string): Observable<any[]> {
        const params = new HttpParams()
            .set('page', `${pageNumber}`)
            .set('pageSize', `${pageSize}`)
            .set('search', `${search}`)
            .set('order', `${orderBy}`);

        return this.api.get(this.apiController, {params}).pipe(map((data) => data));
    }

    get(id: number): Observable<any> {
        return this.api.get(`${this.apiController}/${id}`)
            .pipe(map(data => {
                return {...data};
            }));
    }

    getByLevel(level: number): Observable<any[]> {
        return this.api.get(`${this.apiController}/by-level/${level}`)
            .pipe(map(data => {
                return Array.isArray(data) ? data : [data];
            }));
    }

    add(item: any): Observable<any> {
        return this.api.post(`${this.apiController}`, item);
    }

    update(item: any): Observable<any> {
        if (!item.id) {
            throw new Error('ID is required for update');
        }
        return this.api.put(`${this.apiController}/${item.id}`, item);
    }

    delete(item: any): Observable<any> {
        if (!item.id) {
            throw new Error('ID is required for delete');
        }
        return this.api.delete(`${this.apiController}/${item.id}`, item);
    }
}

